import { Component } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { Globals } from '../../shared/Globals';

/**
 * Tiny modal recording the Gespreksdatum (doc §12) when a submission moves to
 * `interview_scheduled` via drag or per-card select on the board (the detail
 * view uses an inline date field instead). The date is optional — skipping
 * still moves the card, it just leaves interview_at unset.
 * Closes with an ISO date string, null (skipped), or CANCEL (revert the move).
 */
export const INTERVIEW_DIALOG_CANCEL = Symbol('interview-dialog-cancel');

export type InterviewDialogResult = string | null | typeof INTERVIEW_DIALOG_CANCEL;

@Component({
  selector: 'bst-interview-date-dialog',
  template: `
    <nb-card class="interview-date-dialog">
      <nb-card-header>
        <h1>{{ 'crm.interview.title' | translate }}</h1>
        <p class="subtext">{{ 'crm.interview.sub' | translate }}</p>
      </nb-card-header>
      <nb-card-body>
        <input nbInput fullWidth
               [placeholder]="'enterdate' | translate"
               [nbDatepicker]="interviewPicker"
               [(ngModel)]="date">
        <nb-datepicker #interviewPicker></nb-datepicker>
      </nb-card-body>
      <nb-card-footer>
        <button nbButton type="button" (click)="cancel()">{{ 'cancel' | translate }}</button>
        <div>
          <button nbButton ghost type="button" (click)="skip()">{{ 'crm.interview.skip' | translate }}</button>
          <button nbButton type="button" status="primary" [disabled]="!date" (click)="confirm()">{{ 'crm.interview.confirm' | translate }}</button>
        </div>
      </nb-card-footer>
    </nb-card>
  `,
  styles: [`
    .interview-date-dialog { min-width: 24rem; }
    .subtext { margin: 0.25rem 0 0; font-size: 0.85rem; color: var(--text-hint-color); }
    nb-card-footer { display: flex; justify-content: space-between; }
  `],
  standalone: false,
})
export class InterviewDateDialogComponent {

  date: Date | null = null;

  constructor(private ref: NbDialogRef<InterviewDateDialogComponent>) {}

  confirm(): void {
    if (!this.date) { return; }
    this.ref.close(Globals.toISODate(this.date));
  }

  skip(): void {
    this.ref.close(null);
  }

  cancel(): void {
    this.ref.close(INTERVIEW_DIALOG_CANCEL);
  }
}
